import styled from "@emotion/styled";

export const ScreenContainer = styled.div`
  padding: 0 2rem;
  overflow: hidden;
`;

export const Container = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;

export const H1 = styled.h1`
  margin-top: 30px;
  padding: 20px 0px;
  text-align: left;
`;
export const H3 = styled.h3`
  margin-top: 30px;
  text-align: left;
`;
export const Div1 = styled.div`
  border-right: 1px solid #e4e4e4;
  padding-right: 1rem;
`;
export const Div2 = styled.div`
  padding-left: 1rem;
`;
export const Data = styled.div`
  width: 100%;
  margin: auto;
  padding: 20px 0;

  & table {
    width: 100%;
  }
  & tr {
    text-align: left;
  }
`;

export const FormContainer = styled.div`
  display: grid;
  align-items: center;
  align-content: flex-start;
  padding-top: 10px;

  & Form {
    width: 100%;
  }
`;
export const InputContainer = styled.div`
  width: 80%;
  padding: 30px 0;
`;
export const Btn = styled.button`
  margin-top: 2rem;
  padding: 0.8rem 38px;
  border: 0.5px solid #000;
  border-radius: 40px;
  background-color: transparent;
  color: #080808;
  font-size: 10px;
  font-weight: 700;
  text-align: center;
  cursor: pointer;
`;
